<div class="sign-shell">
  <div class="br-card sign-card">
    <div class="brand">OptixWay</div>

    <p *ngIf="loading" class="muted">Loading…</p>

    <div *ngIf="invalid" class="br-alert br-alert--danger invalid-message">
      <h2>Link unavailable</h2>
      <p>This signing link is invalid or has expired. Please ask your representative to resend it.</p>
    </div>

    <ng-container *ngIf="summary && !invalid">
      <div *ngIf="done" class="done">
        <br-icon>check_circle</br-icon>
        <h2>Thank you — this contract is signed.</h2>
        <p class="muted">You can safely close this page.</p>
        <button type="button" class="br-btn br-btn--outline-secondary" (click)="viewPdf()">View contract</button>
      </div>

      <ng-container *ngIf="!done">
        <h2>{{ summary.title }}</h2>
        <div class="summary">
          <div><span class="k">Contract</span> {{ summary.contractNo }}</div>
          <div><span class="k">Provider</span> {{ summary.providerName }}</div>
          <div><span class="k">Customer</span> {{ summary.customerName }}</div>
        </div>
        <button type="button" class="br-btn br-btn--outline-secondary review-btn" (click)="viewPdf()">
          <br-icon>picture_as_pdf</br-icon> Review the contract
        </button>

        <mat-form-field appearance="outline" class="full">
          <mat-label>Full legal name</mat-label>
          <input matInput [(ngModel)]="signerName" maxlength="255">
        </mat-form-field>

        <app-signature-pad (signatureChange)="onSignature($event)"></app-signature-pad>

        <mat-checkbox [(ngModel)]="agreed" class="agree">
          I have reviewed and agree to this contract, and this is my legal signature.
        </mat-checkbox>

        <div *ngIf="error" class="br-alert br-alert--danger err">{{ error }}</div>

        <button type="button" class="br-btn br-btn--primary sign-btn" (click)="submit()" [disabled]="!canSign">
          {{ saving ? 'Signing…' : 'Sign contract' }}
        </button>
      </ng-container>
    </ng-container>
  </div>
</div>
